import { Pipe, PipeTransform } from '@angular/core';
import { formatMoney } from '../../@core/utils/money-formatter';

@Pipe({
    name: 'money'
})
export class MoneyPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) return '';
        const n = Number(value);
        return formatMoney(n);
    }
}